<template>
  <div>
    <div class="my-calls-view">
      <div
        class="current-call-item"
        v-for="(item, index) in parkedCallsList"
        :key="index"
      >
        <parked-call
          :parkingSpace="item.parkingSpace"
          :parkingLot="item.parkingLot"
          :callerName="item.callerName"
          :callerNumber="item.callerNumber"
        />
      </div>
      <div
        class="current-call-item"
        v-for="item in myCallsList"
        :key="item.channel"
      >
        <connected-call
          :type="type"
          :channel="item.channel"
          :systemname="item.systemname"
          :cidnum="item.cidnum"
          :cidname="item.cidname"
          :direction="item.direction"
          :duration="item.duration"
          :disabled-buttons="item.disabledButtons"
          :call-item="item"
          :status="item.status"
          :softphone-call="item.softphoneCall"
          :sipHandle="item.sipHandle"
          :onHold="item.onHold"
          :atxferActive="item.atxferActive"
          :atxferCallerId="item.atxferCallerId"
          :conferencing="item.conferencing"
          :participants="item.participants"
          :confBridgeId="item.bridgeId"
          :dtmfNums="item.dtmfNums ? item.dtmfNums : []"
        />
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import ConnectedCall from './connected-call';
import ParkedCall from '@/views/hudportal/softphone/components/parked-call';

export default {
  name: 'SalesforceConnectedCalls',
  components: {
    ConnectedCall,
    ParkedCall
  },
  props: {
    type: {required: true}
  },
  computed: {
    ...mapGetters("mycurrentcalls", { myCallsList: "list" }),
    ...mapGetters("myparkedcalls", { parkedCallsList: "list" }),
  }
}

</script>
